module.exports = __webpack_public_path__ + "static/img/del.179b4c02.svg";